import { Link } from "react-router-dom";
import { Award, ShieldCheck, HardHat, Sparkles } from "lucide-react";
import { SITE, STATS } from "@/lib/site";
import { useSiteContent } from "@/lib/siteContent";

const VALUES = [
  { icon: Award, t: "Mükemmellik", d: "Her uygulamaya lüks markaların standartlarıyla yaklaşırız." },
  { icon: ShieldCheck, t: "Garanti", d: "10 yıla varan işçilik ve malzeme garantisi." },
  { icon: HardHat, t: "Güvenli Şantiye", d: "İSG sertifikalı ustalar, düzenli ve organize sahalar." },
  { icon: Sparkles, t: "Şeffaflık", d: "Fiyattan uygulamaya, her aşamada açık iletişim." },
];

const DEFAULTS = {
  headline: `${SITE.yearsOfExperience}+ yılı aşkın ustalık, tek bir aile çatısı altında.`,
  intro: "Kardeşler Yapı, Eskişehir merkezli bir aile şirketi olarak su yalıtımı, çatı yalıtımı, ısı yalıtımı ve çatı tadilat & onarım alanlarında uzmanlaşmış bir ekiptir. Yarım asra uzanan birikimimizi, modern uygulama standartları ve premium malzemelerle birleştirerek müşterilerimize uzun ömürlü çözümler sunuyoruz.",
  mission: "Yapıların ömrünü uzatmak, enerji verimliliğini artırmak ve şantiyelerde insan emeğine saygı duyarak lüks standardı erişilebilir kılmak.",
  cta_text: "Bir sonraki projeniz için tek aramayla uzman ekibimizle tanışın.",
};

export default function About() {
  const c = useSiteContent("about", DEFAULTS);
  return (
    <div data-testid="about-page">
      <section className="px-6 md:px-12 pt-28 pb-20 grain">
        <p className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#d4af37]">— Hakkımızda</p>
        <h1 className="mt-4 font-display font-extrabold tracking-tighter text-5xl sm:text-7xl lg:text-[8rem] leading-[0.85] max-w-5xl text-balance whitespace-pre-line">
          {c.headline || DEFAULTS.headline}
        </h1>
        <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-10">
          <p className="lg:col-span-7 text-white/65 text-lg leading-relaxed text-pretty whitespace-pre-line">
            {c.intro || DEFAULTS.intro}
          </p>
          <div className="lg:col-span-5 glass p-7 space-y-4">
            <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#d4af37]">Misyon</div>
            <p className="text-white/75 leading-relaxed whitespace-pre-line">{c.mission || DEFAULTS.mission}</p>
          </div>
        </div>
      </section>

      <section className="border-y border-white/5 bg-[#0a0a0a]">
        <div className="grid grid-cols-2 md:grid-cols-4 divide-x divide-white/5">
          {STATS.map((s) => (
            <div key={s.label} className="p-8 md:p-10">
              <div className="font-display text-4xl md:text-6xl text-[#d4af37] tracking-tighter">{s.value}</div>
              <div className="mt-2 font-mono text-[11px] uppercase tracking-[0.25em] text-white/55">{s.label}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="px-6 md:px-12 py-24">
        <h2 className="font-display font-extrabold tracking-tighter text-4xl md:text-6xl">Değerlerimiz</h2>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {VALUES.map((v) => (
            <div key={v.t} className="border border-white/5 bg-[#0a0a0a] p-7 hover:border-[#d4af37]/40 transition">
              <v.icon className="h-9 w-9 text-[#d4af37]" />
              <div className="mt-6 font-display text-2xl tracking-tight">{v.t}</div>
              <p className="text-white/55 mt-2 text-sm leading-relaxed">{v.d}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="px-6 md:px-12 py-20 border-t border-white/5 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <h2 className="font-display font-extrabold tracking-tighter text-4xl md:text-5xl whitespace-pre-line">
            {c.cta_text || DEFAULTS.cta_text}
          </h2>
        </div>
        <div className="lg:col-span-5">
          <Link
            to="/iletisim"
            data-testid="about-cta"
            className="inline-flex items-center gap-3 bg-[#d4af37] text-[#121212] hover:bg-white px-7 py-4 font-display uppercase tracking-[0.18em] text-sm transition"
          >
            Bizimle İletişime Geçin →
          </Link>
        </div>
      </section>
    </div>
  );
}
